
import React, { useState } from "react";
import { Dropdown, Menu, Modal, DatePicker, Form, Button, message } from "antd";
import { FiMoreHorizontal } from "react-icons/fi";
import dayjs from "dayjs";
import { ThunderboltOutlined } from '@ant-design/icons';
import httpInjectorService from 'services/http-injector.service';
import { toast } from 'react-toastify';

const TimelineMenu = ({epicobj, projectId, onDeleteEpic }) => {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [form] = Form.useForm();

  // ----- Edit Dates -----
  const openEditDates = () => {
    setIsEditModalOpen(true);
    form.setFieldsValue({
      startDate: epicobj.startDate ? dayjs(epicobj.startDate) : null,
      dueDate: epicobj.dueDate ? dayjs(epicobj.dueDate) : null,
    });
  };
 

  const handleUpdate = async () => {
    try {
      const values = await form.validateFields();
      const payload = {
        epic_id:epicobj.epic_id,
        project_id: projectId,
        epic_name: epicobj.name,
        start_date: values.startDate?.format("YYYY-MM-DD"),
        due_date: values.dueDate?.format("YYYY-MM-DD"),
      };

    let response=await httpInjectorService.UpdateEpicDetails(payload);
    if(response.status==="success"){
         toast.success(response.message, {
                position: 'top-right',
                autoClose: 3000,
              });
              setIsEditModalOpen(false);

    }else{
          toast.error(response.message, {
                position: 'top-right',
                autoClose: 3000,
              });
        
    }
     
      
    } catch (err) {
      message.error("Failed to update epic dates.");
    }
  };

  // ----- Delete Epic -----
  const openDeleteConfirm = () => setIsDeleteModalOpen(true);

  const handleDelete = async () => {
    try {
      await onDeleteEpic(epicobj.id);
      message.success("Epic deleted successfully!");
      setIsDeleteModalOpen(false);
    } catch (err) {
      message.error("Failed to delete epic.");
    }
  };

  // ----- Menu -----
  const menu = (
    <Menu
      items={[
        {
          key: "editDates",
          label: "Edit Dates",
          onClick: openEditDates,
        }
        
      ]}
    />
  );

  return (
    <>
      <Dropdown overlay={menu} trigger={["click"]}>
        <FiMoreHorizontal style={{ cursor: "pointer" }} />
      </Dropdown>

      {/* Edit Dates Modal */}
      <Modal
        title="Edit Dates"
        open={isEditModalOpen}
        onCancel={() => setIsEditModalOpen(false)}
        footer={[
          <Button key="cancel" onClick={() => setIsEditModalOpen(false)}>
            Cancel
          </Button>,
          <Button key="confirm" type="primary" onClick={handleUpdate}>
            Confirm
          </Button>,
        ]}
      >
        <div style={{ marginBottom: 20 }}> {/* Epic Name */} 
            <div style={{ display: "flex", alignItems: "center", marginBottom: 12 }}>
                 <ThunderboltOutlined style={{ color: "#722ed1", fontSize: 18, marginRight: 8 }} /> <strong>{epicobj.name}</strong> 
                 </div> {/* Dates in two columns */} 
                 <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}> 
                    {/* Start date */} <div>
                         <div style={{ fontSize: 12, color: "#888" }}>Start date</div> 
                         <div style={{ fontSize: 14 }}>{epicobj.start_date
        ? dayjs(epicobj.start_date).format("YYYY-MM-DD")
        : "—"}</div> 
                         </div> {/* Due date */} <div>
                             <div style={{ fontSize: 12, color: "#888" }}>Due date</div>
                              <div style={{ fontSize: 14 }}>{epicobj.due_date
        ? dayjs(epicobj.due_date).format("YYYY-MM-DD")
        : "—"}</div> 
                              </div> 
                              </div>
                               </div>
        
        <Form form={form} layout="vertical">
          <Form.Item name="startDate" label="Start date">
            <DatePicker format="YYYY-MM-DD" style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item name="dueDate" label="Due date">
            <DatePicker format="YYYY-MM-DD" style={{ width: "100%" }} />
          </Form.Item>
        </Form>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal
        title="Delete Epic"
        open={isDeleteModalOpen}
        onCancel={() => setIsDeleteModalOpen(false)}
        footer={[
          <Button key="cancel" onClick={() => setIsDeleteModalOpen(false)}>
            Cancel
          </Button>,
          <Button key="delete" type="primary" danger onClick={handleDelete}>
            Delete
          </Button>,
        ]}
      >
        <p>Are you sure you want to delete the epic <b>{epicobj.name}</b>?</p>
      </Modal>
    </>
  );
};

export default TimelineMenu;
